import { Module } from "common/types/Module"
import routes from "./routes"

export default {
  name: "login",
  routes
} as Module
